import { render, staticRenderFns } from "./NuevosIngresosComponent.vue?vue&type=template&id=ca77bee4&scoped=true"
import script from "./NuevosIngresosComponent.vue?vue&type=script&lang=js"
export * from "./NuevosIngresosComponent.vue?vue&type=script&lang=js"
import style0 from "./NuevosIngresosComponent.vue?vue&type=style&index=0&id=ca77bee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca77bee4",
  null
  
)

export default component.exports